import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);
  const [join, setJoin] = useState({ open: false, type: "membership", plan: "" });

  const reload = useCallback(async () => {
    const { data } = await http.get("/content");
    setContent(data);
    return data;
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const openJoin = useCallback((opts = {}) => {
    setJoin({ open: true, type: opts.type || "membership", plan: opts.plan || "" });
  }, []);
  const closeJoin = useCallback(() => setJoin((j) => ({ ...j, open: false })), []);

  return (
    <SiteContext.Provider value={{ content, reload, join, openJoin, closeJoin }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
